export default __webpack_public_path__ + "static/media/rumImage.66f7eabb.jpg";